import { render } from "./ReportTable.vue?vue&type=template&id=39288f12"
import script from "./ReportTable.vue?vue&type=script&lang=js"
export * from "./ReportTable.vue?vue&type=script&lang=js"

import "./ReportTable.vue?vue&type=style&index=0&id=39288f12&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__